import { z } from 'zod'

// the manual arm-threshold override, expressed in exactly one of two forms:
//   - price: an absolute arm price (one-shot — cleared when a buy fires from it)
//   - dropPercent: a percent below the running peak (a standing rule that tracks the peak)
// both take precedence over the automatic drop/shift modes (see BotSession.getArmThreshold)
// and are mutually exclusive — setting one clears the other.
export const setBotManualThresholdSchema = z
  .object({
    price: z.number().positive().optional(),
    dropPercent: z.number().min(0).max(100).optional(),
  })
  .refine((v) => (v.price === undefined) !== (v.dropPercent === undefined), {
    message: 'provide exactly one of price or dropPercent',
  })

export type SetBotManualThresholdDto = z.infer<typeof setBotManualThresholdSchema>

// override the shift% the bot uses for the lot ladder and the cooldown (last-fill) anchor.
export const setBotManualShiftSchema = z.object({
  shiftPercent: z.number().min(0).max(100),
})

export type SetBotManualShiftDto = z.infer<typeof setBotManualShiftSchema>
